<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-v-component
      heading="Список договоров"
      link="components/data-tables"
    />

    <base-material-card
      color="primary"
      icon="mdi-file-document"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Договора
        </div>
      </template>
      <v-row>
        <!--<v-col cols="4">
          <v-btn color="green" dark min-width=200 @click="$router.push('/accident/create/short')"><v-icon>mdi-plus</v-icon>Оформить договор</v-btn>
        </v-col>-->
        <v-col cols="8">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            label="Поиск"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
      </v-row>

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        multi-sort
        :footerProps="datatable_footer"
      >
       <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
        {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
        </template>
        <template v-slot:top>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.date.from"
                    label="Дата начала"
                    type="date"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.date.to"
                    label="Дата конца"
                    type="date"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="form.kind"
                    label="Тип договора"
                    :items="select.kind"
                    clearable
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.name"
                    label="ФИО"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.number"
                    label="Номер договора"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-select
                    v-model="form.state"
                    label="Статус"
                    :items="select.state"
                    clearable
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.vin"
                    label="VIN"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.doc_insurance.series"
                    label="Серия полиса"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.doc_insurance.number"
                    label="Номер полиса"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.vehicle_number"
                    label="Гос. номер"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-select
                  :items="select.insurer"
                    v-model="form.insurer"
                    label="Страховая"
                    @change="load"
                    clearable
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.model"
                    label="Марка авто"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.phone"
                    label="Номер телефона"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="1" v-if="$store.state.user.role!=9">
                  <v-select
                    v-model="form.transaction"
                    :items="select.transaction"
                    label="Свойства"
                    multiple
                    @keyup.enter="load"
                    @change="load"
                  >
                    <template v-slot:selection="{item}">
                      <v-icon
                        v-if="item.type == 1"
                        :color="item.color"
                      >
                        mdi-credit-card-refund
                      </v-icon>
                      <v-icon
                        v-if="item.type == 2"
                        :color="item.color"
                      >
                        mdi-credit-card-marker-outline
                      </v-icon>
                      <v-icon
                        v-if="item.type == 3"
                        :color="item.color"
                      >
                        mdi-alert-decagram
                      </v-icon>
                    </template>
                    <template v-slot:item="{item, attrs}">
                      <v-checkbox :input-value="attrs.inputValue" />
                      <v-icon
                        v-if="item.type == 1"
                        :color="item.color"
                      >
                        mdi-credit-card-refund
                      </v-icon>
                      <v-icon
                        v-if="item.type == 2"
                        :color="item.color"
                      >
                        mdi-credit-card-marker-outline
                      </v-icon>
                      <v-icon
                        v-if="item.type == 3"
                        :color="item.color"
                      >
                        mdi-alert-decagram
                      </v-icon>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    v-model="form.deleted"
                    label="Показывать удаленные"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    @click="load"
                  >
                    Поиск
                  </v-btn>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="secondary"
                    dark
                    min-width="250"
                    class="mb-2"
                    @click="clear"
                  >
                    Сбросить фильтры
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            large
            color="primary"
            class="mr-2"
            @click="sheetitem = item, sheet = true"
          >
            mdi-cog
          </v-icon>
          {{ item.state_string }}
        </template>
        <template v-slot:item.number="{item}">
          <div class="table_item">
            <span class="table_item__title">
              {{ item.number }}/{{ item.date_number }} от {{ item.date_formatted }}
            </span><br>
            <span class="table_item__subtitle">
              {{ item.kind_string }}
            </span>
          </div>
        </template>
        <template v-slot:item.owner="{item}">
          <span class="table_item">
            <span class="table_item__title">
              {{ item.owner.surname }} {{ item.owner.name }} {{ item.owner.patronymic }}
            </span><br>
            <span class="table_item__subtitle">
              {{ item.owner.birthday }} г.р.
            </span><br>
            <span class="table_item__subtitle">
              {{ item.owner.phone }}
            </span>
          </span>
        </template>
        <template v-slot:item.transaction="{item}">
          <v-icon
            :color="get_color(item,1)"
            @click="$router.push('/transaction/list?contract=' + item.number + '/' + item.date_number)"
          >
            mdi-credit-card-refund
          </v-icon>
          <v-icon
            :color="get_color(item,2)"
            @click="$router.push('/transaction/list?contract=' + item.number + '/' + item.date_number)"
          >
            mdi-credit-card-marker-outline
          </v-icon>
          <v-icon
            v-if="get_color(item,3)!='white'"
            :color="get_color(item,3)"
            @click="$router.push('/transaction/list?contract=' + item.number + '/' + item.date_number)"
          >
            mdi-alert-decagram
          </v-icon>
        </template>
        <template v-slot:item.sum="{item}">
          <div class="table_item">
            <span class="table_item__title text-uppercase">
              {{ Number(item.sum).money() }}
            </span><br>
            <span class="table_item__subtitle">
              Сумма договора
            </span>
          </div>
        </template>
        <template v-slot:item.vehicle="{ item }">
          <div class="table_item">
            <span class="table_item__title text-uppercase">
              {{ item.accident_item.first.vehicle.model }}, госномер: {{ item.accident_item.first.vehicle.number }}
            </span><br>
            <span class="table_item__subtitle">
              {{ item.accident_item.first.vehicle.vin }}
            </span>
          </div>
        </template>
        <template v-slot:item.insurance="{ item }">
          <div class="table_item">
            <span class="table_item__title text-uppercase">
              {{ dict.insurer[item.insurer] }}
            </span><br>
            <span class="table_item__title text-uppercase">
              {{ item.accident_item.first.insurance.doc.series }} {{ item.accident_item.first.insurance.doc.number }}
            </span><br>
            <span class="table_item__subtitle">
              {{ item.insurer_contract }}
            </span>
          </div>
        </template>
      </v-data-table>
    </base-material-card>
    <v-dialog
      v-model="dialog.show"
      persistent
      scrollable
      max-width="50%"
    >
      <v-card class="elevation-1">
        <v-card-title class="headline">
          Изменение статуса
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="4">
                <v-select
                  v-model="dialog.item.state"
                  :items="select.state"
                  label="Статус"
                />
              </v-col>
              <v-col cols="4" v-if="dialog.item.state == 2 || dialog.item.state == 3 || dialog.item.state == 4 || dialog.item.state == 5 || dialog.item.state == 6 || dialog.item.state == 7">
                <v-text-field                 
                  v-model="dialog.item.state_date"
                  type="date"
                  label="Дата"
                />
              </v-col>
              <v-col cols="4" v-if="dialog.item.state == 2">
                <v-text-field
                  v-model="dialog.item.state_time"
                  type="time"
                  label="Время"
                />
              </v-col>
              <v-col cols="12" v-if="dialog.item.state == 2">
                <v-select
                  v-model="dialog.item.user"
                  :items="select.users"
                  item-text="surname"
                  item-value="id"
                  label="Исполнитель"
                />
              </v-col>
              <v-col cols="12" v-if="dialog.item.state == 2">
                <v-text-field
                  v-model="dialog.item.place"
                  label="Место осмотра"
                />
              </v-col>
              <v-col cols="4" v-if="dialog.item.state == 5">
                <v-text-field
                  v-model="dialog.item.state_sum"
                  type="number"
                  label="Сумма выплаты от СК"
                />
              </v-col>
              <v-col cols="4" v-if="dialog.item.state == 5">
                <v-text-field
                  v-model="dialog.item.insurer_contract"
                  label="Номер убытка"
                />
              </v-col>
              <v-col cols="4" v-if="dialog.item.state == 5">
                <v-text-field
                  v-model="dialog.item.insurer_act"
                  label="Номер акта"
                />
              </v-col>
              <v-col cols="4" v-if="dialog.item.state == 5">
                <v-text-field
                  v-model="dialog.item.insurer_other"
                  label="Прочий идентификатор СК"
                />
              </v-col>
              <v-col cols="4" v-if="dialog.item.state == 5">
                <v-text-field
                  v-model="dialog.item.state_sum_1"
                  type="number"
                  label="Этап 1"
                />
              </v-col>
              <v-col cols="4" v-if="dialog.item.state == 5">
                <v-text-field
                  v-model="dialog.item.state_sum_2"
                  type="number"
                  label="Этап 2"
                />
              </v-col>
              <v-col cols="4" v-if="dialog.item.state == 5">
                <v-text-field
                  v-model="dialog.item.state_sum_3"
                  type="number"
                  label="Этап 3"
                />
              </v-col>
              <v-col cols="4">
                <v-row>
                  <v-col cols="12">
                    <v-select
                      v-if="dialog.item.state == 5"
                      v-model="dialog.item.state_payment_type"
                      :items="select.payment_type"
                      label="Способ возмещения"
                      @change="payment_type_change"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-if="dialog.item.state == 9 || (dialog.item.state == 5 && dialog.item.state_payment_type == 2)"
                      v-model="dialog.item.state_service"
                      :items="select.services"
                      label="Автосервис"
                      @change="choose_service"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-if="dialog.item.state == 9 || (dialog.item.state == 5 && dialog.item.state_payment_type == 2)"
                      v-model="dialog.item.state_sum_repair"
                      type="number"
                      label="Сумма ремонта"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-if="dialog.item.state == 5 && dialog.item.state_payment_type == 1"
                      v-model="dialog.item.state_sum_client"
                      :mask="'#'"
                      type="number"
                      label="Сумма выплаты клиенту"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                v-if="dialog.item.state == 9 || (dialog.item.state == 5 && (dialog.item.state_payment_type == 2 || dialog.item.state_payment_type == 1))"
                cols="8"
              >
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="dialog.item.recipient.name"
                      name="recipient_name"
                      label="Наименование получателя"
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="dialog.item.recipient.inn"
                      name="recipient_inn"
                      label="ИНН"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="dialog.item.recipient.kpp"
                      name="recipient_kpp"
                      label="КПП"
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="dialog.item.recipient.bank_name"
                      name="recipient_bank_name"
                      label="Банк"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="dialog.item.recipient.bic"
                      name="recipient_bic"
                      label="БИК"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="dialog.item.recipient.ks"
                      label="К/с"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="dialog.item.recipient.rs"
                      :counter="20"
                      label="Р/с"
                      :rules="[(v) => validateRs() || 'Неверно указан номер счета']"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="dialog.item.recipient.description"
                      label="Назначение"
                    />
                  </v-col>
                </v-row>
              </v-col>

              <!--<v-col cols="12">
                  <v-checkbox
                    v-model="dialog.item.state_dop"
                    v-if="dialog.item.state == 5 && dialog.item.state_sum != dialog.item.sum"
                    label="Сформировать дополнительное соглашение?"
                  />
                </v-col>-->
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-btn
            color="primary"
            flat
            @click="dialog.show = false"
          >
            Назад
          </v-btn>
          <v-spacer />
          <v-btn
            color="red"
            flat
            @click="changeState"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-bottom-sheet v-model="sheet">
      <v-list>
        <v-list-group v-model="sheetmenu">
          <v-list-tile slot="activator">
            <v-list-tile-action>
              <v-icon>mdi-build</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Действия</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-item @click="show_change_state" v-if="$store.state.user.role != 9">
            <v-list-item-content>
              Изменить статус
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="$router.push('/contract/change?id=' + sheetitem.id)">
            <v-list-item-content>
              Изменить договор
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="$router.push('/contract/view?id=' + sheetitem.id)">
            <v-list-item-content>
              Открыть договор
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="cancel_contract_show(sheetitem)">
            <v-list-item-content>
              Расторгнуть договор
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="complete_contract_show(sheetitem)">
            <v-list-item-content>
              Исполнить договор
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="$router.push('/accident/view/' + sheetitem.accident)">
            <v-list-item-content>
              Перейти к ДТП
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group>
          <v-list-tile slot="activator">
            <v-list-tile-action>
              <v-icon>mdi-folders</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Документы</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-item @click="getDoc({id:'63d7b9892033dc67bfd86e73'})">
            <v-list-item-content>
              <v-list-item-title class="display-1">
                Паспорт Комаров
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="getDoc({id:'5db00d13334e9e414c1f3885'})">
            <v-list-item-content>
              <v-list-item-title class="display-1">
                Приказ директора
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-for="(line, index) in sheetitem.docs.filter(a=>a.hide!=true)"
            :key="index"
            @click="getDoc(line)"
          >
            <v-list-item-content>
              <v-list-item-title class="display-1">
                {{ line.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-bottom-sheet>
    <v-dialog persistent  v-model="contract_cancel.show">
      <v-card>
        <v-card-title>Расторжение договора</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="contract_cancel.data.date"
                type="date"
                label="Дата расторжения договора"
                />
            </v-col>
            <v-col cols="8" v-if="!contract_cancel.data.complete">
              <v-select
                v-model="contract_cancel.data.user"
                :items="select.clients.filter(a=>a.contract_agent)"
                label="Выберите представителя"
                item-value="id"
                @change="(a)=>check_user(a)"
                clearable
              >
                <template v-slot:selection="{item}">
                  <v-list>
                    <v-list-item-content>
                      <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list>
                </template>
                <template v-slot:item="{item}">
                  <v-list>
                    <v-list-item-content>
                      <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" v-if="$store.state.user.role != 9">
              <v-data-table
                :headers="contract_cancel.headers"
                :items="contract_cancel.transactions"
                :footerProps="datatable_footer"
                show-select
                v-model="contract_cancel.data.transactions"
              >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
                </template>
                <template v-slot:item.sum="{item}">
                  <v-chip
                    :color="getSumColor(item)"
                    dark
                  >
                    {{ Number(item.sum).money() }}
                  </v-chip>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    large
                    color="primary"
                    class="mr-2"
                    @click="sheetitem = item, sheet = true"
                  >
                    mdi-cog
                  </v-icon>
                </template>
                <template v-slot:item.checked="{item}">
                  <v-checkbox
                    v-model="item.checked"
                  />
                </template>
                <template v-slot:item.date="{item}">
                  {{ format(item.date.create) }}<br>
                </template>
                <template v-slot:item.type="{item}">
                  {{ dict.type[item.type] }}<br>
                </template>
                <template v-slot:item.state="{item}">
                  <v-chip
                    v-if="item.state!=1"
                    :color="getStateColor(item)"
                    dark
                  >
                    {{ dict.transaction_state[item.state] }}
                  </v-chip>
                  <span v-else>{{ dict.transaction_state[item.state] }}</span><br>
                  <span v-if="item.payments && item.payments.length>0 && item.state == 1">Частичная</span>
                </template>
                <template v-slot:item.contract="{item}">
                  {{ contract_cancel.data.contract_data.number }}/{{ format_contract_date(contract_cancel.data.contract_data.date) }}<br>{{ format(contract_cancel.data.contract_data.date) }}
                </template>
              </v-data-table>
            </v-col> 
            <v-col cols="4" v-if="!contract_cancel.data.complete">
              <v-select
                v-model="contract_cancel.data.reason"
                label="Причина расторжения"
                :items="select.cancel_reason"
                />
            </v-col>
            <v-col cols="4" v-if="contract_cancel.data.complete">
              <v-text-field
                v-model="contract_cancel.data.sum"
                label="Сумма"
                type="number"
                />
            </v-col>
            <v-col cols="8">
              <v-text-field
                v-model="contract_cancel.data.comment"
                label="Комментарий"
              />
            </v-col>       
          </v-row>
        </v-card-text>
        <v-card-actions>
          
          <v-btn @click="contract_cancel.show = false" color="error">
            <span class="mx-5">Отмена</span>
          </v-btn>
          <v-btn @click="cancel_contract" class="ml-auto" color="success">
            <span class="mx-5">Сохранить</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style scoped>
.table_item {
  font-size: 0.929rem;
  padding-bottom: 12px;
}
.table_item:first-of-type {
  padding-top: 12px;
}

.table_item__title {
  font-size: 0.929rem;
}
.table_item__subtitle{
  font-size: 0.875rem;
  line-height: 1.2;
  color: #999;
}

</style>
<script>
  //import suggest from '../../libs/suggestions.min.17.12.0.dev.js'
  import suggest from 'suggestions-jquery'
  import moment from 'moment'
  import $ from 'jquery'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      datatable_footer: {
        itemsPerPageText: 'Показывать по', pageText: 'из',
        itemsPerPageAllText: 'Все'
      },
      dialog: {
        show: false,
        item: {
          recipient: {},
        },
      },
      contract_cancel: {
        show: false,
        contract: {},
        data: {
          date: moment().format('YYYY-MM-DD'),
          user: '',
          transactions: [],
          reason: 0,
          comment: ''
        },
        transactions: [],
        headers: [{
          text: 'Дата',
          value: 'date',
        },
        {
          text: 'Статус',
          value: 'state',
        },
        {
          text: 'Договор',
          value: 'contract',
        },
        {
          text: 'Тип транзакции',
          value: 'type',
        },
        {
          text: 'Сумма',
          value: 'sum',
        },
        {
          text: 'Назначение',
          value: 'description',
        },
        {
          text: 'Наименование плательщика',
          value: 'debet.name',
        },
        {
          text: 'Наименование получателя',
          value: 'credit.name',
        }]
      },
      sheet: false,
      sheetmenu: true,
      sheetitem: {
        docs: [],
      },
      headers: [
        {
          sortable: false,
          text: 'Действия',
          value: 'action',
        },
        {
          text: 'Договор',
          value: 'number',
        },
        {
          text: 'Свойства',
          value: 'transaction',
        },
        {
          text: 'Сумма',
          value: 'sum',
        },
        {
          text: 'Собственник',
          value: 'owner',
        },
        {
          text: 'ТС',
          value: 'vehicle',
        },
        {
          text: 'Страховой полис',
          value: 'insurance',
        },
      ],
      items: [],
      search: undefined,
      form: {
        insurer: 0,
        date: {
          from: '',
          to: '',
        },
        kind: 0,
        doc_insurance: {
          series: '',
          number: '',
        },
        transactions: true,
        all_transactions: true,
      },
      select: {
        cancel_reason: [],
        clients: [],
        insurer: [],
        state: [
          { value: 1, text: 'Новый' },
          { value: 2, text: 'Осмотр назначен' },
          { value: 3, text: 'Осмотр проведен' },
          { value: 4, text: 'Документы сданы в СК' },
          { value: 5, text: 'Выплата согласована СК' },
          { value: 6, text: 'Деньги получены от СК' },
          { value: 7, text: 'Передано в архив' },
          { value: 8, text: 'Удален' },
          { value: 9, text: 'Ремонт завершен' },
          { value: 10, text: 'Расторжен'}
        ],
        kind: [
          { value: 1, text: 'Оформление документов' },
          { value: 2, text: 'Договор Цессии' },
        ],
        payment_type: [
          { value: 1, text: 'Деньгами' },
          { value: 2, text: 'Ремонт Евроком' },
        ],
        services: [],
        transaction: [{
                        type: 1,
                        color: 'red',
                        value: 11,
                      },
                      {
                        type: 1,
                        color: 'yellow',
                        value: 12,
                      },
                      {
                        type: 1,
                        color: 'green',
                        value: 13,
                      },
                      {
                        type: 2,
                        color: 'red',
                        value: 21,
                      },
                      {
                        type: 2,
                        color: 'yellow',
                        value: 22,
                      },
                      {
                        type: 2,
                        color: 'green',
                        value: 23,
                      },
                      {
                        type: 3,
                        color: 'red',
                        value: 31,
                      },
                      {
                        type: 3,
                        color: 'yellow',
                        value: 32,
                      }],
        users: [],
      },
      dict: {
        transaction_state: {
          1: 'Новая',
          2: 'Исполнена',
          3: 'Удалена по расторжению договора',
          8: 'Удалена',
        },
        direction: {
          1: 'Приход',
          2: 'Расход',
        },
        type_reverse: {},
        type: {},
        state: {
          1: 'Новый',
          2: 'Осмотр назначен',
          3: 'Осмотр проведен',
          4: 'Документы сданы в СК',
          5: 'Выплата согласована СК',
          6: 'Деньги получены от СК',
          7: 'Исполнен',
          8: 'Удален',
          9: 'Ремонт завершен',
          10: 'Расторгнут'
        },
        kind: {
          1: 'Оформление документов',
          2: 'Договор Цессии',
        },
        insurer: {},
      },
      suggestion: {
        bank_name: false,
        bic: false,
        kpp: false,
        inn: false,
        name: false,
      },
    }),
    watch: {
      'dialog.item.recipient.bank_name': function () {
        if (!this.suggestion.bank_name && $('[name=recipient_bank_name]').length > 0) {
          this.suggestion.bank_name = true
          $('[name=recipient_bank_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.dialog.item.recipient.bank_name = data.data.name.full || data.data.name.payment
              this.dialog.item.recipient.bic = data.data.bic
              this.dialog.item.recipient.ks = data.data.correspondent_account
            },
          })
        }
      },
      'dialog.item.recipient.bic': function () {
        if (!this.suggestion.bic && $('[name=recipient_bic]').length > 0) {
          this.suggestion.bic = true
          $('[name=recipient_bic]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'BANK',
            count: 5,
            onSelect: data => {
              this.dialog.item.recipient.bank_name = data.data.name.full || data.data.name.payment
              this.dialog.item.recipient.bic = data.data.bic
              this.dialog.item.recipient.ks = data.data.correspondent_account
            },
          })
        }
      },
      'dialog.item.recipient.inn': function () {
        if (!this.suggestion.inn && $('[name=recipient_inn]').length > 0) {
          this.suggestion.inn = true
          $('[name=recipient_inn]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.dialog.item.recipient.name = data.data.name.full
              this.dialog.item.recipient.inn = data.data.inn
              this.dialog.item.recipient.kpp = data.data.kpp
            },
          })
        }
      },
      'dialog.item.recipient.name': function () {
        if (!this.suggestion.name && $('[name=recipient_name]').length > 0) {
          this.suggestion.name = true
          $('[name=recipient_name]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.dialog.item.recipient.name = data.data.name.full
              this.dialog.item.recipient.inn = data.data.inn
              this.dialog.item.recipient.kpp = data.data.kpp
            },
          })
        }
      },
      'dialog.item.recipient.kpp': function () {
        if (!this.suggestion.kpp && $('[name=recipient_kpp]').length > 0) {
          this.suggestion.kpp = true
          $('[name=recipient_kpp]').suggestions({
            token: 'eae7f9493d3e1f729fd183f9197cf1fd22c7fbcc',
            type: 'PARTY',
            count: 5,
            onSelect: data => {
              this.dialog.item.recipient.name = data.data.name.full
              this.dialog.item.recipient.inn = data.data.inn
              this.dialog.item.recipient.kpp = data.data.kpp
            },
          })
        }
      },
    },
    mounted: function () {
      if (this.$store.state.user.role == 9) {
        this.headers =  [
          {
            sortable: false,
            text: 'Действия',
            value: 'action',
          },
          {
            text: 'Договор',
            value: 'number',
          },
          {
            text: 'Сумма',
            value: 'sum',
          },
          {
            text: 'Собственник',
            value: 'owner',
          },
          {
            text: 'ТС',
            value: 'vehicle',
          },
          {
            text: 'Страховой полис',
            value: 'insurance',
          }
        ]
      }
      this.axios.post('/api/clients/list/', {})
        .then(response => {
          if (!response.data.error) {
            this.select.clients = response.data.data
            console.log(this.form.commissar)
          } else {

          }
        })
        .catch(e => {
          console.log(e)
        })
      for (let x in this.$store.state.dict.transaction_type) {
        this.dict.type_reverse[this.$store.state.dict.transaction_type[x].key] = x
        this.dict.type[Number(x)] = this.$store.state.dict.transaction_type[x].name
      }
      this.form.date.from = moment().format('YYYY-MM-DD')
      this.form.date.to = moment().format('YYYY-MM-DD')
      for (let x in this.$store.state.dict.services) {
        this.select.services.push({ value: Number(x), text: this.$store.state.dict.services[x].name, data: this.$store.state.dict.services[x] })
      }
      
      for (let x in this.$store.state.dict.contract_cancel) {
        this.select.cancel_reason.push({ value: Number(x), text: this.$store.state.dict.contract_cancel[x].name })
      }
      for (let x in this.$store.state.dict.insurer) {
        this.dict.insurer[Number(x)] = this.$store.state.dict.insurer[x].name
        this.select.insurer.push({
          value: Number(x),
          text: this.$store.state.dict.insurer[x].name,
          eurocom: this.$store.state.dict.insurer[x].eurocom
        })
      }
      let store_filters = JSON.parse(localStorage.getItem('contract_filters') ? localStorage.getItem('contract_filters') : '{}')

      if (store_filters) {
        if (store_filters.date) {
          if (store_filters.date.from) {
            this.form.date.from = store_filters.date.from
          }
          if (store_filters.date.to) {
            this.form.date.to = store_filters.date.to
          }
        }
        if (store_filters.kind) {
          this.form.kind = store_filters.kind
        }
        if (store_filters.name) {
          this.form.name = store_filters.name
        }
        if (store_filters.number) {
          this.form.number = store_filters.number
        }
        if (store_filters.state) {
          this.form.state = store_filters.state
        }
        if (store_filters.id) {
          this.form.id = store_filters.id
        }
        if (store_filters.accident) {
          this.form.accident = store_filters.accident
        }
        if (store_filters.deleted) {
          this.form.deleted = store_filters.deleted
        }
      }
      if (this.$route.query.id) {
        this.form.id = this.$route.query.id
      }
      if (this.$route.query.accident) {
        this.form.accident = this.$route.query.accident
      }
      this.axios.post('/api/user/get/', this.form)
        .then(response => {
          if (!response.data.error) {
            this.select.users = response.data.data
          } else {
            this.$store.commit('snackbar', response.data.error || 'Ошибка при получении данных')
          }
        })
        .catch(e => {
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
      this.load()
    },
    methods: {
      format_contract_date: function (date) {
        return moment(date).format('DDMM')
      },
      show_change_state: function() {
        this.dialog.item = this.sheetitem.current_state ||
        { 
          id: this.sheetitem.id, 
          user: this.$store.state.user.id, 
          state: this.sheetitem.state || 1, 
          recipient: {}, 
          requisites: this.sheetitem.owner.requisites, 
          requisites_name: `${this.sheetitem.owner.surname} ${this.sheetitem.owner.name} ${this.sheetitem.owner.patronymic}`
        }
        this.dialog.item.recipient = this.dialog.item.recipient || {}
        
        this.sheet = false
        this.dialog.show = true
      },
      check_user: function(id) {
        var user = this.select.clients.filter(a=>a.id == id)[0]
        console.log(moment(user.agent_doc.date).diff(moment(), 'days'))
        if (user.agent_doc.type == 2 && moment(user.agent_doc.date).diff(moment(), 'days') < 0) {
          alert('Срок действия доверенности данного представителя истек (' + moment(user.agent_doc.date).format('DD.MM.YYYY') + ')')
        }
      },
      getSumColor: function (item) {
        if (item.direction == 1) return 'green'
        return 'red'
      },
      getStateColor: function (item) {
        return 'green'
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      cancel_contract: function() {
        this.axios.post('/api/contract/cancel', this.contract_cancel.data)
          .then(result => {
            if (!result.data.error) {
              this.contract_cancel.show = false
              this.load()
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
      cancel_contract_show: function(contract) {
        this.contract_cancel.data = {
          contract: contract.id,
          contract_data: contract,
          date: moment().format('YYYY-MM-DD'), 
          user: '', 
          transactions:[], 
          reason: 0
        }
        this.sheet = false
        this.contract_cancel.show = true
        this.axios.post('/api/transaction/list', {contract: contract.id})
          .then(result => {
            if (!result.data.error) {
              this.contract_cancel.transactions = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
      complete_contract_show: function(contract) {
        this.contract_cancel.data = {
          contract: contract.id,
          contract_data: contract,
          date: moment().format('YYYY-MM-DD'), 
          user: '', 
          transactions:[], 
          reason: 0,
          complete: true,
          sum: contract.sum
        }
        this.sheet = false
        this.contract_cancel.show = true
        this.axios.post('/api/transaction/list', {contract: contract.id})
          .then(result => {
            if (!result.data.error) {
              this.contract_cancel.transactions = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
      get_color: function (item, type) {
        if (!item.transactions) { return 'red' }
        if (type == 1) {
          var transactions = item.transactions.filter(a => a.type == this.dict.type_reverse['client'] && a.state != 9)
          if (transactions.length == 0) return 'red'
          let color = 'green'
          for (let x in transactions) {
            if (transactions[x].state == 1) { color = 'yellow' }
          }
          return color
        }
        if (type == 2) {
          var transactions = item.transactions.filter(a => a.type == this.dict.type_reverse['insurer'] && a.state != 9)
          if (transactions.length == 0) return 'red'
          let color = 'green'
          for (let x in transactions) {
            if (transactions[x].state == 1) { color = 'yellow' }
          }
          return color
        }
        if (type == 3) {
          var transactions = item.transactions.filter(a => a.type == this.dict.type_reverse['insurer'] && a.state == 1)
          if (transactions.length > 0) {
            let color = 'white'
            for (let x in transactions) {
              if (moment().diff(moment(transactions[x].created), 'days') > 15) { color = 'yellow' }
              if (moment().diff(moment(transactions[x].created), 'days') > 20) { color = 'red' }
            }
            return color
          } else {
            return 'white'
          }
        }
      },
      clearSuggestions: function () {
        this.suggestion.bank_name = false
        this.suggestion.bic = false
        this.suggestion.kpp = false
        this.suggestion.inn = false
        this.suggestion.name = false
      },
      validateRs: function () {
        let error = {}
        let rs = this.dialog.item.recipient.rs
        let bik = this.dialog.item.recipient.bic
        var result = false
        if (typeof rs === 'number') {
          rs = rs.toString()
        } else if (typeof rs !== 'string') {
          rs = ''
        }
        if (!rs.length) {
          error.code = 1
          error.message = 'Р/С пуст'
        } else if (/[^0-9]/.test(rs)) {
          error.code = 2
          error.message = 'Р/С может состоять только из цифр'
        } else if (rs.length !== 20) {
          error.code = 3
          error.message = 'Р/С может состоять только из 20 цифр'
        } else {
          var bikRs = bik.toString().slice(-3) + rs
          var checksum = 0
          var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]
          for (var i in coefficients) {
            checksum += coefficients[i] * (bikRs[i] % 10)
          }
          if (checksum % 10 === 0) {
            result = true
          } else {
            error.code = 4
            error.message = 'Неправильное контрольное число'
          }
        }
        return result
      },
      payment_type_change: function () {
        this.clearSuggestions()
        console.log(this.dialog.item.state_payment_type)
        if (this.dialog.item.state_payment_type == 1) {
          console.log(this.dialog.item.requisites)
          this.dialog.item.recipient = this.dialog.item.requisites
          if (this.dialog.item.requisites_name) {
            this.dialog.item.recipient.name = this.dialog.item.requisites_name
          }
        }
      },
      choose_service: function () {
        this.dialog.item.recipient = this.select.services.filter(a => a.value == this.dialog.item.state_service)[0].data
      },
      changeState: function () {
        this.clearSuggestions()
        this.axios.post('/api/contract/state', this.dialog.item)
          .then(result => {
            if (!result.data.error) {
              this.dialog.show = false
              this.load()
            }
          })
          .catch(e => {
            this.dialog.show = false
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      getDoc: function (item) {
        let form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      clear: function () {
        this.form = {
          date: {
            from: '',
            to: '',
          },
          kind: 0,
          doc_insurance: {
            series: '',
            number: '',
          },
          transactions: true,
          all_transactions: true,
        },
        this.form.date.from = moment().format('YYYY-MM-DD')
        this.form.date.to = moment().format('YYYY-MM-DD')
        this.load()
      },
      load: function (clear) {
        localStorage.setItem('contract_filters', JSON.stringify(this.form))
        this.clearSuggestions()
        this.axios.post('/api/contract/get', this.form)
          .then(result => {
            this.form.id = null
            this.form.accident = null
            if (!result.data.error) {
              this.items = result.data.data
              if (this.form.transaction && this.form.transaction.length > 0) {
                this.items = this.items.filter(a => this.filter_transaction(a))
              }
              for (let x in this.items) {
                this.items[x].date_formatted = moment(this.items[x].date).format('DD.MM.YYYY')
                this.items[x].owner.birthday = moment(this.items[x].owner.birthday).format('DD.MM.YYYY')
                this.items[x].date_number = moment(this.items[x].date).format('DDMM')
                this.items[x].state_string = this.dict.state[this.items[x].state]
                this.items[x].kind_string = this.dict.kind[this.items[x].kind]
              }
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
      filter_transaction: function (a) {
        let first = ((
          this.form.transaction.filter(a => a == 11).length > 0 &&
          this.get_color(a, 1) == 'red'
        ) ||
          (
            this.form.transaction.filter(a => a == 12).length > 0 &&
          this.get_color(a, 1) == 'yellow'
          ) ||
          (
            this.form.transaction.filter(a => a == 13).length > 0 &&
          this.get_color(a, 1) == 'green'
          )
        )
        let second = (
          (
            this.form.transaction.filter(a => a == 21).length > 0 &&
          this.get_color(a, 2) == 'red'
          ) ||
          (
            this.form.transaction.filter(a => a == 22).length > 0 &&
          this.get_color(a, 2) == 'yellow'
          ) ||
          (
            this.form.transaction.filter(a => a == 23).length > 0 &&
          this.get_color(a, 2) == 'green'
          )
        )
        let third = (
          (
            this.form.transaction.filter(a => a == 31).length > 0 &&
          this.get_color(a, 3) == 'red'
          ) ||
          (
            this.form.transaction.filter(a => a == 32).length > 0 &&
          this.get_color(a, 3) == 'yellow'
          )
        )
        var res =
          (this.form.transaction.filter(a => String(a).startsWith('1')).length == 0 || first) &&
          (this.form.transaction.filter(a => String(a).startsWith('2')).length == 0 || second) &&
          (this.form.transaction.filter(a => String(a).startsWith('3')).length == 0 || third)
        return res
      },
    },
  }
</script>
